import React from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

function DashboardDistribuidor() {
  const { sales, tasks } = reportsBarChartData;

  // Datos específicos para el distribuidor autorizado
  const dashboardData = {
    empresasAtendidas: {
      value: 23,
      percentage: 15,
      increase: true
    },
    minoristasAbastecidos: {
      value: 12,
      percentage: 25,
      increase: true
    },
    ingresosGenerados: {
      value: "$100 M",
      percentage: 18,
      increase: true
    },
    licenciasVendidas: {
      value: 2500,
      percentage: 12,
      increase: true
    }
  };

  // Datos para el historial de compras
  const historialCompras = [
    {
      fecha: "01/09/2025",
      plan: "100",
      tests: "100",
      precio: "$99",
      id: "6458"
    },
    {
      fecha: "10/09/2025",
      plan: "500",
      tests: "500",
      precio: "$219",
      id: "5458"
    },
    {
      fecha: "17/09/2025",
      plan: "1000",
      tests: "1000",
      precio: "$389",
      id: "7458M"
    }
  ];

  // Datos para licencias vendidas por mes
  const licenciasVendidasData = [300, 400, 225, 380, 450, 500];
  const meses = ['Abr', 'May', 'Jun', 'Jul', 'Agost', 'Sept'];

  // Datos para ventas por tipo de cliente
  const ventasPorTipo = {
    empresas: 70,
    minoristas: 30
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            {/* Tarjetas de estadísticas principales */}
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="primary"
                  icon="business"
                  title="Empresas Atendidas"
                  count={dashboardData.empresasAtendidas.value}
                  percentage={{
                    color: "success",
                    amount: `+${dashboardData.empresasAtendidas.percentage}%`,
                    label: "vs mes anterior",
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="success"
                  icon="people"
                  title="Minoristas Abastecidos"
                  count={dashboardData.minoristasAbastecidos.value}
                  percentage={{
                    color: "success",
                    amount: `+${dashboardData.minoristasAbastecidos.percentage}%`,
                    label: "vs mes anterior",
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="info"
                  icon="attach_money"
                  title="Ingresos Generados"
                  count={dashboardData.ingresosGenerados.value}
                  percentage={{
                    color: "success",
                    amount: `+${dashboardData.ingresosGenerados.percentage}%`,
                    label: "vs mes anterior",
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="warning"
                  icon="inventory"
                  title="Licencias vendidas"
                  count={dashboardData.licenciasVendidas.value}
                  percentage={{
                    color: "success",
                    amount: `+${dashboardData.licenciasVendidas.percentage}%`,
                    label: "vs mes anterior",
                  }}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>

        <MDBox mb={3}>
          <Grid container spacing={3}>
            {/* Historial de compras al super Admin */}
            <Grid item xs={12} md={6} lg={6}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="primary"
                  borderRadius="lg"
                  coloredShadow="primary"
                >
                  <MDTypography variant="h6" color="white">
                    Historial de compras al super Admin
                  </MDTypography>
                </MDBox>
                <MDBox pt={3} pb={2} px={3}>
                  <MDBox component="div" overflow="auto">
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                          <th style={{ padding: '12px 8px', textAlign: 'left', fontSize: '0.875rem', color: '#757575' }}>Fecha</th>
                          <th style={{ padding: '12px 8px', textAlign: 'left', fontSize: '0.875rem', color: '#757575' }}>Plan</th>
                          <th style={{ padding: '12px 8px', textAlign: 'left', fontSize: '0.875rem', color: '#757575' }}>tests</th>
                          <th style={{ padding: '12px 8px', textAlign: 'left', fontSize: '0.875rem', color: '#757575' }}>Precio</th>
                          <th style={{ padding: '12px 8px', textAlign: 'left', fontSize: '0.875rem', color: '#757575' }}>Id transaccion</th>
                        </tr>
                      </thead>
                      <tbody>
                        {historialCompras.map((compra, index) => (
                          <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                            <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>{compra.fecha}</td>
                            <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>{compra.plan}</td>
                            <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>{compra.tests}</td>
                            <td style={{ padding: '12px 8px', fontSize: '0.875rem', color: '#4caf50' }}>{compra.precio}</td>
                            <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>{compra.id}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </MDBox>
                  <MDBox mt={2} display="flex" justifyContent="space-between">
                    <MDBox>
                      <MDTypography variant="h4" color="primary">6</MDTypography>
                      <MDTypography variant="caption" color="text" fontWeight="medium">
                        TOTAL COMPRAS
                      </MDTypography>
                    </MDBox>
                    <MDBox textAlign="right">
                      <MDTypography variant="h4" color="success">$8.5 M</MDTypography>
                      <MDTypography variant="caption" color="text" fontWeight="medium">
                        INVERSIÓN TOTAL
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>

            {/* Ventas por tipo Cliente */}
            <Grid item xs={12} md={6} lg={6}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="success"
                  borderRadius="lg"
                  coloredShadow="success"
                >
                  <MDTypography variant="h6" color="white">
                    Ventas por tipo Cliente
                  </MDTypography>
                </MDBox>
                <MDBox pt={3} pb={2} px={3}>
                  {/* Simulación de gráfico circular */}
                  <MDBox display="flex" justifyContent="center" alignItems="center" mb={2}>
                    <MDBox 
                      width="200px" 
                      height="200px" 
                      borderRadius="50%" 
                      position="relative"
                      style={{
                        background: `conic-gradient(#1976d2 0deg ${ventasPorTipo.empresas * 3.6}deg, #ff9800 ${ventasPorTipo.empresas * 3.6}deg 360deg)`
                      }}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <MDBox 
                        width="120px" 
                        height="120px" 
                        borderRadius="50%" 
                        bgcolor="white"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <MDTypography variant="h6" color="text">
                          {ventasPorTipo.empresas}% / {ventasPorTipo.minoristas}%
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  
                  {/* Leyenda */}
                  <MDBox display="flex" justifyContent="center" gap={3}>
                    <MDBox display="flex" alignItems="center">
                      <MDBox 
                        width="12px" 
                        height="12px" 
                        bgcolor="#1976d2" 
                        borderRadius="50%" 
                        mr={1}
                      />
                      <MDTypography variant="caption">
                        70% Empresas (1,750 licencias)
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDBox 
                        width="12px" 
                        height="12px" 
                        bgcolor="#ff9800" 
                        borderRadius="50%" 
                        mr={1}
                      />
                      <MDTypography variant="caption">
                        30% Minoristas (750 licencias)
                      </MDTypography>
                    </MDBox>
                  </MDBox>

                  <MDBox mt={3} display="flex" justifyContent="space-between">
                    <MDBox>
                      <MDTypography variant="h4" color="info">$38.0 M</MDTypography>
                      <MDTypography variant="caption" color="text" fontWeight="medium">
                        INGRESOS EMPRESAS
                      </MDTypography>
                    </MDBox>
                    <MDBox textAlign="right">
                      <MDTypography variant="h4" color="warning">$10.2 M</MDTypography>
                      <MDTypography variant="caption" color="text" fontWeight="medium">
                        INGRESOS MINORISTAS
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>

        <MDBox mb={3}>
          <Grid container spacing={3}>
            {/* Licencias vendidas por mes */}
            <Grid item xs={12} md={6} lg={6}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="warning"
                  borderRadius="lg"
                  coloredShadow="warning"
                >
                  <MDTypography variant="h6" color="white">
                    Licencias vendidas por mes (Últimos 6 meses)
                  </MDTypography>
                </MDBox>
                <MDBox pt={4} pb={3} px={3} display="flex" justifyContent="center" alignItems="center">
                  <MDBox width="100%">
                    <ReportsBarChart
                      chart={{
                        labels: ["Abr", "May", "Jun", "Jul", "Agost", "Sept"],
                        datasets: {
                          label: "Licencias",
                          data: [300, 400, 225, 380, 450, 500],
                          backgroundColor: "#ff9800", // Color amarillo/naranja warning
                          borderColor: "#ff9800",
                          borderWidth: 1,
                        },
                      }}
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>

            {/* Ventas a Minoristas y Empresas */}
            <Grid item xs={12} md={6} lg={6}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Ventas a Minoristas y Empresas
                  </MDTypography>
                </MDBox>
                <MDBox pt={3} pb={2} px={3}>
                  <MDBox component="div" overflow="auto">
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                          <th style={{ padding: '12px 8px', textAlign: 'left', fontSize: '0.875rem', color: '#757575' }}>Fecha de venta</th>
                          <th style={{ padding: '12px 8px', textAlign: 'left', fontSize: '0.875rem', color: '#757575' }}>Cliente</th>
                          <th style={{ padding: '12px 8px', textAlign: 'left', fontSize: '0.875rem', color: '#757575' }}>Tipo</th>
                          <th style={{ padding: '12px 8px', textAlign: 'left', fontSize: '0.875rem', color: '#757575' }}>licencias vendidas</th>
                          <th style={{ padding: '12px 8px', textAlign: 'left', fontSize: '0.875rem', color: '#757575' }}>Precio unitario</th>
                          <th style={{ padding: '12px 8px', textAlign: 'left', fontSize: '0.875rem', color: '#757575' }}>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                          <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>08/09/2025</td>
                          <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>XYZ</td>
                          <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>Empresa</td>
                          <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>850</td>
                          <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>$250</td>
                          <td style={{ padding: '12px 8px', fontSize: '0.875rem', color: '#4caf50' }}>$20,000</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                          <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>10/09/2025</td>
                          <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>Hernan gutierrez</td>
                          <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>Minorista</td>
                          <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>80</td>
                          <td style={{ padding: '12px 8px', fontSize: '0.875rem' }}>$250</td>
                          <td style={{ padding: '12px 8px', fontSize: '0.875rem', color: '#4caf50' }}>$11,500</td>
                        </tr>
                      </tbody>
                    </table>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DashboardDistribuidor;